import * as z from "zod";
import { mutator } from "./mutator";

export const deleteFeatureFlag = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    flag: { kind: "featureFlag", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:feature_flags_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { flag } }) => {
    await tx.mutate.featureFlags.delete({ id: flag.id });
  },
});
